interface ToastProps {
  message: string | null;
}

export function Toast({ message }: ToastProps) {
  return message ? <div className="schedule-toast" role="status">{message}</div> : null;
}
